<template>
  <el-dialog
    title="浙江商标代理机构无从业人员名单"
    :visible.sync="noemploy_dialogVisible"
    width="70%"
    :before-close="handleClose"
    :close-on-click-modal="true"
  >
    <div>
      <el-form :model="queryParams" ref="queryParamsRef" label-width="140px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="机构名称" prop="agencyName">
              <el-input v-model="queryParams.agencyName" placeholder="请输入机构名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码" prop="unifiedSocialCreditCode">
              <el-input
                v-model="queryParams.unifiedSocialCreditCode"
                placeholder="请输入统一社会信用代码"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col style="text-align: center;">
            <el-button type="primary" @click="getList">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column type="index" width="55" label="序号" align="center">
            <template
              slot-scope="scope"
            >{{ (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="agencyName" label="机构名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column
            prop="unifiedSocialCreditCode"
            label="统一社会信用代码"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
  </el-dialog>
</template>
      <script>
import { getNoemployList } from "@/api/index";
export default {
  props: {
    noemploy_dialogVisible: {
      type: Boolean,
      default: false
    },
    unifiedSocialCreditCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
        queryParams: {
        pageSize: 10,
        pageNum: 1,
        agencyName: "",
        unifiedSocialCreditCode: ""
      },
      tableData: [],
      total: 0
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleClose() {
      this.$emit("update:noemploy_dialogVisible", false);
    },
    getList() {
      getNoemployList({ ...this.queryParams }).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    resetForm() {
      this.$refs.queryParamsRef.resetFields();
      this.getList();
    }
  }
};
</script>
      <style lang="less" scoped>
.main {
  width: 1200px;
  min-height: calc(100vh - 421px);
  margin: 0px auto;
  background-color: #fff;
  margin-top: 20px;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 0px 20px;
}
/deep/ .el-dialog {
  margin-top: 8vh !important;
}
</style>